import { z } from 'src/lib';
import { OperacionADLFields } from './fields';
import { schemaEntityWithId } from 'src/types';

export const schemaOperacionADL = z
    .object({
        [OperacionADLFields.CodPais]: z.number(),
        [OperacionADLFields.NombrePais]: z.string(),
        [OperacionADLFields.CodUnidadNegocio]: z.number().nullable(),
        [OperacionADLFields.UnidadNegocio]: z.string().nullable(),
        [OperacionADLFields.CodSectorComercial]: z.number().nullable(),
        [OperacionADLFields.SectorComercial]: z.string().nullable(),
        [OperacionADLFields.FechaSolicitud]: z.coerce.date().nullable(),
        [OperacionADLFields.FechaVencimiento]: z.coerce.date().nullable(),
        [OperacionADLFields.CodEstado]: z.number(),
        [OperacionADLFields.DescEstado]: z.string(),
        [OperacionADLFields.FechaAprobacion]: z.coerce.date().nullable(),

        [OperacionADLFields.RazonSocial]: z.string().nullable(),
        [OperacionADLFields.CodClienteTipo]: z.number().nullable(),
        [OperacionADLFields.DescClienteTipo]: z.string().nullable(),
        [OperacionADLFields.NroCuenta]: z.string().nullable(),
        // [OperacionADLFields.CodLegislacionTipo]: z.number().nullable(),
        [OperacionADLFields.DescLegislacionTipo]: z.string().nullable(),
        [OperacionADLFields.EntidadPuenteAcreedora]: z.string().nullable(),

        [OperacionADLFields.Moneda]: z.string().nullable(),
        [OperacionADLFields.Monto]: z.string().nullable(),
        [OperacionADLFields.ComisionEstructuracion]: z.string().nullable(),
        [OperacionADLFields.TasaInteres]: z.string().nullable(),
        [OperacionADLFields.Plazo]: z.string().nullable(),
        [OperacionADLFields.TipoAmortizacionCapital]: z.string().nullable(),
        [OperacionADLFields.FrecuenciaPagoInteres]: z.string().nullable(),

        [OperacionADLFields.Garantias]: z.boolean().nullable(),
        [OperacionADLFields.DetalleGarantias]: z.string().nullable(),
        [OperacionADLFields.DetalleAforo]: z.string().nullable(),
        [OperacionADLFields.Precancelable]: z.boolean().nullable(),
        [OperacionADLFields.CondicionesPrecancelacion]: z.string().nullable(),

        [OperacionADLFields.FechaAlta]: z.coerce.date().nullable(),
        [OperacionADLFields.IdUsuarioAlta]: z.number(),
        [OperacionADLFields.NombreUsuarioAlta]: z.string(),
        [OperacionADLFields.ApellidoUsuarioAlta]: z.string(),
        [OperacionADLFields.IdUsuarioUltMod]: z.number().nullable(),
        
        [OperacionADLFields.EstadoFinalizado]: z.boolean(),
        [OperacionADLFields.PermiteEditarOperacion]: z.boolean(),
        [OperacionADLFields.PermiteEliminarOperacion]: z.boolean(),
        [OperacionADLFields.IdMensaje]: z.number().nullable(),
        [OperacionADLFields.CodVirtualCliente]: z.number().nullable(),
        [OperacionADLFields.CodVirtualLegislacion]: z.number().nullable(),
    })
    .merge(schemaEntityWithId);

export type OperacionADL = z.infer<typeof schemaOperacionADL>;